import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import * as devisConf from '@/configuration/devisConf';
import { AUCUN } from '@/configuration/optionBlocage/optionBlocage';
import { CATEGORIE_PRESTATION } from '@/configuration/catalogue/produitConf';

function generationLigneCommande(produitAssocie) {
  const ligneCommande = genererLigneCommande();
  ligneCommande.prixUnitaire = produitAssocie.prixUnitaire;
  ligneCommande.produitId = produitAssocie.id;
  ligneCommande.uniteVente = produitAssocie?.uniteVente || devisConf.UNITE;
  ligneCommande.etatObtenu = AUCUN;
  ligneCommande.dateEtatObtenu = null;
  ligneCommande.selected = false;
  ligneCommande.quantite = 1;
  ligneCommande.libelle = produitAssocie.libelle;
  ligneCommande.numerique = false;
  ligneCommande.produit = {};
  ligneCommande.produit.reference = produitAssocie.reference;
  ligneCommande.produit.preduitPrestation = produitAssocie;
  ligneCommande.typeProduit = CATEGORIE_PRESTATION;
  ligneCommande.type = devisConf.NORMAL;
  ligneCommande.tauxTva = produitAssocie?.tauxTva ?? null;
  ligneCommande.totalHt = (produitAssocie.quantite || 1) * produitAssocie.prixUnitaire;
  ligneCommande.referenceEcheancier = null;
  ligneCommande.fournisseur = null;
  ligneCommande.fournisseurId = null;
  ligneCommande.aFacturer = true;
  ligneCommande.libelleFournisseur = null;
  return ligneCommande;
}

export default function generationToutesLignesCommandesByPrestation(produitsAssocies, tauxTva) {
  const lignesCommandes = [];
  if (produitsAssocies) {
    lignesCommandes.push(generationLigneCommande(produitsAssocies, tauxTva));
    if (produitsAssocies.liaisonsTarif) {
      produitsAssocies.liaisonsTarif.forEach((liaisonTarif => {
        lignesCommandes.push(generationLigneCommande(liaisonTarif, tauxTva));
      }));
    }
  }
  return lignesCommandes;
}
